import { StyleSheet } from 'aphrodite';
import constants from '../../../constants/styles';
import center from '../../../../node_modules/@turf/center';
let {
  USER_PARENT_LABEL_COLOR,
  USER_PARENT_VALUE_COLOR,
  USER_PARENT_BG_COLOR,
  USER_PARENT_HOVER_BG_COLOR,
  USER_CHILD_BG_COLOR,
  LOGIN_FORM_BG_COLOR,
  WHITE,
  BLACK
} = constants;

let styles = {
  base: {
    display: 'flex',
    backgroundColor: USER_PARENT_BG_COLOR,
    padding: '20px 30px 25px',
    borderRadius: 8,
    marginBottom: 10,
    position: 'relative',

    ':hover': {
      backgroundColor: USER_PARENT_HOVER_BG_COLOR
    }
  },

  field: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1.1em',
    color: USER_PARENT_VALUE_COLOR,
    paddingLeft: 1,
    paddingRight: 0,
    width: '13%',
    textAlign: center,
    position: 'relative'
  },
  adminstyle: {
    paddingLeft: 0
  },
  value: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  label: {
    fontSize: '0.7em',
    fontWeight: 800,
    textTransform: 'uppercase',
    color: USER_PARENT_LABEL_COLOR,
    marginBottom: 5,
    width: '100%',
    textAlign: 'center'
  },
  subbase: {
    backgroundColor: USER_CHILD_BG_COLOR,
    color: USER_PARENT_LABEL_COLOR,
    textTransform: 'uppercase',
    fontSize: '0.9em',
    fontWeight: 800,
    padding: '20px 30px 20px 80px',
    ':hover': {
      backgroundColor: USER_PARENT_HOVER_BG_COLOR
    }
  },
  firstZone: {
    border: 0
  },
  icon: {
    cursor: 'pointer',
    fontWeight: 'bold',
    margin: 'auto 0'
  },
  iconHidden: {
    visibility: 'hidden'
  },
  options: {
    margin: 'auto 0 auto auto',
    maxHeight:'196px'
  },
  editwidth: {
    width: '25%'
  },
  specialwidth: {
    width: '100%'
  },
  ellipsis: {
    position: 'absolute',
    right: '2%',
    width: 30,
    top: 37
  },
  email: {
    textAlign: 'left'
  },
  logo: {
    width: 160,
    margin: 30
  },
  outline: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    alignItems: 'center',
    width: 470,
    backgroundColor: LOGIN_FORM_BG_COLOR,
    padding: '20px 50px',
    color: WHITE
  },
  msg: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: WHITE,
    marginBottom: 30
  },
  link: {
    padding: '2px 18px',
    alignItems: 'center',
    color: BLACK
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/users/userRow.styles.js